//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'MenuSports',
  data() {
    return {
      savingMap: {},
      //sports: []
    }
  },
  computed: {
    sports() {
      const all = this._.get(this.$store.state, 'sports', []) || []
      
      const filtered = this._.filter(all, o => {
        if (o.category === 'sport' && (o.event_count + o.outright_count) > 0) return true
        if (o.is_parent) return true
        return false
      })
      
      const favIds = Array.isArray(this.user?.favorite_sports)
        ? this.user.favorite_sports.map(Number)
        : []
      const favSet = new Set(favIds)
      
      const byId = new Map()
      for (const s of filtered) {
        const sid = Number(s.id)
        if (!byId.has(sid)) byId.set(sid, s)
      }
      
      const favorites = favIds.map(id => byId.get(id)).filter(Boolean)
      const rest = filtered.filter(s => !favSet.has(Number(s.id)))

      return [...favorites, ...rest]
    }
  },
  filters: {

  },
  methods: {
    toNum(v) { return Number(v) },
    isSaving(id) { return !!this.savingMap[this.toNum(id)] },
    setSaving(id, val) {
      const nid = this.toNum(id)
      if (val) this.$set(this.savingMap, nid, true)
      else this.$delete(this.savingMap, nid)
    },
    getURL: function (sport) {
      if (sport.event_count > 0 || sport.is_parent) {
        return this.localePath('/' + sport.translated_slug + '/')
      }
      return this.localePath('/' + sport.translated_slug + '/')
    },
    
    isSportFavorite(sportId) {
      if (!this.user || !Array.isArray(this.user.favorite_sports)) return false
      return this.user.favorite_sports.some(x => Number(x) === sportId)
    },

    async toggleSportFavorite(sportId) {
      const id = Number(sportId)
      
      if (!this.user) {
        this.$modal.show("modal-login");
        return;
      }
      if (this.isSaving(id)) return;

      this.setSaving(id, true)
      
      try {
        const { data } = await this.$auth().post('/api/sport/favorites/sports', { id_sport: id })

        if (!data?.result) {
          console.error('toggleSportFavorite error', data);
          return
        }

        const serverId = Number(data.id_sport)
        const action = data.action
        
        if (serverId === id) {
          if (action === 'add') this.$store.commit('auth/addFavoriteSport', id)
          else if (action === 'delete') this.$store.commit('auth/removeFavoriteSport', id)
        } else {
          if (action === 'add') this.$store.commit('auth/addFavoriteSport', serverId)
          else if (action === 'delete') this.$store.commit('auth/removeFavoriteSport', serverId)
        }
      } catch (e) {
        this.$store.commit('auth/setFavoriteSports', prev)
        console.error('toggleSportFavorite error', e)
      } finally {
        this.setSaving(id, false);
      }
    }
  }
}
